import type { CSSProperties, MouseEvent, ReactNode } from 'react';
import { usePagePreviewHover } from './usePagePreviewHover';
import type { PreviewablePage } from './PagePreviewPopover';

// Drop-in wrapper for a single page-preview card: reports hover to the shared
// PagePreviewHoverProvider so the floating title / description / classification
// popover appears beside it. Must be rendered inside a PagePreviewHoverProvider.
// Extra onMouseEnter/onMouseLeave compose with the hover wiring for cards that
// already react to hover (e.g. a segment thumb highlighting its band).
export function PagePreviewHoverCard({
  page,
  className,
  style,
  children,
  onMouseEnter,
  onMouseLeave,
}: {
  page: PreviewablePage;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
  onMouseEnter?: (e: MouseEvent<HTMLDivElement>) => void;
  onMouseLeave?: () => void;
}) {
  const { show, hide } = usePagePreviewHover();
  return (
    <div
      className={className}
      style={style}
      onMouseEnter={(e) => {
        onMouseEnter?.(e);
        show(page, e.currentTarget.getBoundingClientRect());
      }}
      onMouseLeave={() => {
        onMouseLeave?.();
        hide();
      }}
    >
      {children}
    </div>
  );
}
